import { BodyText } from '@paypalcorp/pp-react-text';
import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';

import getLocaleMessages from '../../../utils/localesMessages';
import BasicInputField from '../../fields/BasicInputField';
import { renderSwitchComponent } from '../../switchPanels/SwitchPanel';

const { advanced: { url = {} } = {} } = getLocaleMessages(
  'buttonsV3/advancedUrls'
);

const renderBasicInputField = (props) => {
  return <BasicInputField {...props} />;
};

const AdvancedUrls = ({ noCancelReturn }) => {
  const isChecked = noCancelReturn === 'no';

  return (
    <>
      <Field
        id="advanced-url-switch"
        name="noCancelReturn"
        title={url.switch.title}
        subTitle={url.switch.subtitle}
        component={renderSwitchComponent}
        isChecked={isChecked}
        reversed={true}
      />

      {isChecked && (
        <>
          <BodyText className="instruction" size="lg">
            {url.cancelUrl?.instruction}
          </BodyText>
          <Field
            id="cancelReturn"
            name="cancelReturn"
            type="text"
            label={url.cancelUrl?.placeholder}
            component={renderBasicInputField}
            helpText={url.cancelUrl.example}
          />

          <BodyText className="instruction" size="lg">
            {url.returnUrl?.instruction}
          </BodyText>
          <Field
            id="return"
            name="return"
            type="text"
            label={url.returnUrl?.placeholder}
            component={renderBasicInputField}
            helpText={url.returnUrl?.example}
          />
        </>
      )}
    </>
  );
};

AdvancedUrls.propTypes = {
  noCancelReturn: PropTypes.string,
};

export default AdvancedUrls;
